/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDlvryCheckoutV2DeliveryOptions contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum filterDeliveryModeOption {
    none = 'none',
    filterOutNonCarrierDeliveryMode = 'filterOutNonCarrierDeliveryMode'
}

export const enum useDefaultDeliveryOption {
    none = 'none',
    displaySelectedDeliveryOption = 'displaySelectedDeliveryOption',
    notDisplaySelectedDeliveryOption = 'notDisplaySelectedDeliveryOption'
}

export interface IDlvryCheckoutV2DeliveryOptionsConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    subHeader?: Msdyn365.RichText;
    filterDeliveryModeOption?: filterDeliveryModeOption;
    useDefaultDeliveryOption?: useDefaultDeliveryOption;
    className?: string;
    multipleAddressShippingEnabled?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    clientRender?: boolean;
    timeoutToCallRetail?: number;
}

export interface IDlvryCheckoutV2DeliveryOptionsResources {
    deliveryOptionsNotFound: string;
    genericErrorMessage: string;
    errorMessageTitle: string;
    ariaLabelText: string;
    priceFree: string;
    saveBtnLabel: string;
    editBtnLabel: string;
    cancelBtnLabel: string;
    deliveryOptionAriaLabel: string;
    cartLineGroupShippingAddressLabel: string;
    cartLineGroupDeliveryOptionsLabel: string;
    cartLineGroupDeliveryOptionsText: string;
    discountStringText: string;
    quantityDisplayString: string;
    productDimensionTypeColor: string;
    productDimensionTypeSize: string;
    productDimensionTypeStyle: string;
    productDimensionTypeAmount: string;
    configString: string;
    shippingChargesString: string;
    deliveryDateLabel: string;
    deliveryDeliveryOptionDescriptionLabel: string;
    pickupDeliveryOptionDescriptionLabel: string;
    noDeliveryDatesErrorText: string;
    deliveryCalenderMissingErrorTitle: string;
    deliveryCalenderMissingErrorText: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IDlvryCheckoutV2DeliveryOptionsProps<T> extends Msdyn365.IModule<T> {
    resources: IDlvryCheckoutV2DeliveryOptionsResources;
    config: IDlvryCheckoutV2DeliveryOptionsConfig;
}
